import React from 'react';
import PropTypes from 'prop-types';

const Event = (props) => {
  const { onChangePage } = props;

  return (
    <React.Fragment>
      <p>Event</p>
      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" name="eventChoice" id="eventRadio1" value="option1" />
        <label className="form-check-label" for="eventRadio1">Exercise</label>
      </div>
      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" name="eventChoice" id="eventRadio2" value="option2" />
        <label className="form-check-label" for="eventRadio2">Journal</label>
      </div>
      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" name="eventChoice" id="eventRadio3" value="option3" />
        <label className="form-check-label" for="eventRadio3">Event</label>
      </div><br />
      <input className='std-input' type='date' /><br />
      <input className='std-input' type='text' placeholder='Enter Title' /><br />
      <input className='txt-input' type='textarea' placeholder='Enter Event' /><br />
      <button className='btn btn-info' onClick = { () => onChangePage('Calendar') }>Calendar</button>
      <button className='btn btn-info' onClick = { () => onChangePage('Event') }>Add</button>
    </React.Fragment>
  )
}

Event.propType = {
  onChangePage: PropTypes.func
}

export default Event;